import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

const getZoneId = () => Number(localStorage.getItem("zone_id"));

export const fetchInvestigationManager = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.INVESTIGATIONMANAGER.LIST, {
    params: {
      limit,
      page_no,
      zone_id: getZoneId(),
      ...filter,
    },
  });
};
export const fetchInvestigationManagerObservation = (
  page_no,
  filter,
  limit = DEFAULT_TOTAL_RECORDS
) => {
  return axiosInstance.get(EndPoints.INVESTIGATIONMANAGER.OBSERVATIONLIST, {
    params: {
      limit,
      page_no,
      zone_id: getZoneId(),
      ...filter,
    },
  });
};
export const createInvestigationCommentList = (payload) => {
  return axiosInstance.post(
    EndPoints.INVESTIGATIONMANAGER.CREATEINVESTIGATIONLIST,
    payload
  );
};
export const createInvestigationInterpretationList = (payload) => {
  return axiosInstance.post(
    EndPoints.INVESTIGATIONMANAGER.CREATEINVESTIGATIONINTERPRETATIONLIST,
    payload
  );
};
export const createHelpmenuList = (payload) => {
  return axiosInstance.post(
    EndPoints.INVESTIGATIONMANAGER.CREATEHELPMENULIST,
    payload
  );
};
export const createObservationList = (payload) => {
  return axiosInstance.post(
    EndPoints.INVESTIGATIONMANAGER.CREATEOBSERVATIONLIST,
    payload
  );
};
export const createInvestigationManager = (payload) => {
  return axiosInstance.post(EndPoints.INVESTIGATIONMANAGER.CREATE, payload);
};

export const updateInvestigationManager = (payload) => {
  const body = { ...payload };
  if (body.tat && (!body.zone_ids || body.zone_ids.length === 0)) {
    const zone_id = getZoneId();
    if (Number.isInteger(zone_id)) {
      body.zone_ids = [zone_id];
    }
  }
  return axiosInstance.put(EndPoints.INVESTIGATIONMANAGER.UPDATE, body);
};

export const updateInvestigationObservationSequence = (payload) => {
  return axiosInstance.put(
    EndPoints.INVESTIGATIONMANAGER.UPDATE_INVESTIGATION_OBSERVATION_SEQUENCE,
    payload
  );
};

export const deleteInvestigationManager = (payload) => {
  const url = EndPoints.INVESTIGATIONMANAGER.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const downloadCSV = () => {
  return axiosInstance.put(EndPoints.INVESTIGATIONMANAGER.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};

export const fetchInvestigationObservationRanges = (id, isRanges) => {
  return axiosInstance.get(
    EndPoints.INVESTIGATIONMANAGER.INVESTIGATION_OBSERVATION_RANGES_LIST,
    {
      params: {
        investigation_id: id,
        add_ranges_also: isRanges,
        zone_id: getZoneId(),
      },
    }
  );
};

export const fetchInvestigationObservations = (
  id,
  page_no,
  filter,
  limit = 2000
) => {
  return axiosInstance.get(
    EndPoints.INVESTIGATIONMANAGER.INVESTIGATION_OBSERVATION_LIST,
    {
      params: {
        investigation_id: id,
        limit,
        page_no,
        zone_id: getZoneId(),
        ...filter,
      },
    }
  );
};

export const deleteInvestigationObservations = (payload) => {
  const url =
    EndPoints.INVESTIGATIONMANAGER.DELETE_INVESTIGATION_OBSERVATION_LIST +
    `/${payload}`;
  return axiosInstance.delete(url);
};

export const updateInvestigationObservations = (payload) => {
  return axiosInstance.put(
    EndPoints.INVESTIGATIONMANAGER.UPDATE_INVESTIGATION_OBSERVATION_LIST,
    payload
  );
};

export const fetchInvestigationComments = (page_no, filter, limit = 2000) => {
  return axiosInstance.get(
    EndPoints.INVESTIGATIONMANAGER.INVESTIGATION_COMMENT_LIST,
    {
      params: {
        limit,
        page_no,
        zone_id: getZoneId(),
        ...filter,
      },
    }
  );
};

export const fetchInvestigationInterpretation = (
  page_no,
  filter,
  limit = 2000
) => {
  return axiosInstance.get(
    EndPoints.INVESTIGATIONMANAGER.INVESTIGATION_INTERPRETATION_LIST,
    {
      params: {
        limit,
        page_no,
        zone_id: getZoneId(),
        ...filter,
      },
    }
  );
};

export const fetchInvestigationHelpMenu = (page_no, filter, limit = 2000) => {
  return axiosInstance.get(
    EndPoints.INVESTIGATIONMANAGER.INVESTIGATION_HELP_MENU_LIST,
    {
      params: {
        limit,
        page_no,
        zone_id: getZoneId(),
        ...filter,
      },
    }
  );
};

export const updateInvestigationDeliveryDays = (payload) => {
  return axiosInstance.put(EndPoints.DELIVERY_DAYS.UPDATE, payload);
};

// investigation observation formula
export const createInvestigationObservationFormula = (payload) => {
  return axiosInstance.post(
    EndPoints.INVESTIGATION_OBSERVATION_FORMULA.CREATE,
    payload
  );
};

export const updateInvestigationObservationFormula = (payload) => {
  return axiosInstance.put(
    EndPoints.INVESTIGATION_OBSERVATION_FORMULA.UPDATE,
    payload
  );
};

export const fetchInvestigationObservationFormula = (id) => {
  return axiosInstance.get(
    `${EndPoints.INVESTIGATION_OBSERVATION_FORMULA.LIST}/${id}`,
    {
      // params: {
      //   id
      //   investigation_id: id,
      //   add_ranges_also: isRanges,
      //   zone_id
      // },
    }
  );
};

export const deleteInvestigationObservationFormula = (payload) => {
  const url =
    EndPoints.INVESTIGATION_OBSERVATION_FORMULA.DELETE + `/${payload}`;
  return axiosInstance.delete(url);
};

export const fetchShowDummyReportData = (investigationId) => {
  console.log(typeof parseInt(investigationId));
  return axiosInstance.get(
    `${EndPoints.INVESTIGATIONMANAGER.SHOW_DUMMY_REPORT_DATA}?investigation_id=${investigationId}`
  );
};
